module.exports = __webpack_public_path__ + "img/sword-air-01.021ffff8.png";